import { type ReactNode } from 'react'

import { Skeleton } from '@/components/ui/Skeleton'
import { useT } from '@/i18n'

/** Suspense fallback for a lazily loaded module. Mirrors the usual page
 *  rhythm (header, KPI strip, table) so the layout does not jump. */
export function RouteFallback(): ReactNode {
  const t = useT()

  return (
    <div role="status" aria-live="polite" aria-busy="true" className="space-y-5 p-1">
      <span className="sr-only">{t('common.loading')}</span>
      <div className="space-y-2">
        <Skeleton className="h-7 w-56" />
        <Skeleton className="h-4 w-80" />
      </div>
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} className="h-24 rounded-lg" />
        ))}
      </div>
      <Skeleton className="h-72 rounded-lg" />
    </div>
  )
}
